import { get, post } from "../../axios-interceptor-setup/apiService";

const BASE_URL = "/daily_metrics";

export const getTopKips = ({ filterdata,activeTab }) => {
    let apiUrl= activeTab=="pdl"? "kpis":"kpis_2"
    return post(`${BASE_URL}/${apiUrl}`, {filterdata:filterdata});
}

export const getTopKipsTCU = (body) => {
    return post(`${BASE_URL}/kpis_2`, body);
}

export const getcetGraph = ({ filterdata,activeTab }) => {
let apiUrl=activeTab=="pdl"?"cet":"cet_2"
    return post(`${BASE_URL}/${apiUrl}`, {filterdata});
}

export const getTotalDrivenVehicleTCU = (body) => {
    return post(`${BASE_URL}/total_driven_graph_2`, body);
}

export const getTotalDrivenVehicle = ({ filterdata,activeTab }) => {
    let apiUrl=activeTab=="pdl"?"total_driven_graph":"total_driven_graph_2"
    return post(`${BASE_URL}/${apiUrl}`, {filterdata});
}